/* eslint-disable react-hooks/exhaustive-deps */
import { InputText } from "primereact/inputtext";
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { DataTable, DataTableFilterMeta, DataTableSelectionSingleChangeEvent } from "primereact/datatable";
import { Column, ColumnEditorOptions } from "primereact/column";
import { useEffect, useMemo, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Toast } from "primereact/toast";
import { classNames } from 'primereact/utils';
import { Panel } from "primereact/panel";
import { Button } from "primereact/button";
import React from "react";
import { Dialog } from "primereact/dialog";
import Chart from "../../models/Chart";
import { Link } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import MaintenanceService from "../../service/MaintenanceService";
import { Dropdown } from "primereact/dropdown";
import autoTable from "jspdf-autotable";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import StripeComplete from "../../models/StripeComplete";
import { InputNumber } from "primereact/inputnumber";
import { Checkbox } from "primereact/checkbox";
import Company from "../../models/Company";

interface DropdownItem {
    name: string;
    code: string;
}

const defaultFilters: DataTableFilterMeta = {
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    stripeStyle: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    stripeDesc: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    stripeNumClr: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
    stripeWthChart: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    stripeBackground: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
    stripeNeckStyle: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    stripeCompanyId: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    stripeStatus: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    stripeAltLoc1: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    stripeAltLoc2: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    stripeAltLoc3: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    stripeAltLoc4: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    stripeAltLoc5: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    stripeAltLoc6: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    stripeUpdUser: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    stripeUpdTs: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    }
};


export default function StripesView() {
    let empty: StripeComplete = {
        stripeStyle: '',
        stripeDesc: '',
        stripeNumClr: 0,
        stripeWthChart: '',
        stripeBackground: '',
        stripeNeckStyle: '',
        stripeCompanyId: 0,
        stripeStatus: '',
        stripeAltLoc1: '',
        stripeAltLoc2: '',
        stripeAltLoc3: '',
        stripeAltLoc4: '',
        stripeAltLoc5: '',
        stripeAltLoc6: '',
        stripeUpdUser: '',
        stripeUpdTs: ''
    };


    const status: DropdownItem[] = useMemo(
        () => [
            { name: 'Active', code: 'A' },
            { name: 'Deleted', code: 'D' }
        ],
        []
    );

    const [listValues, setListValues] = useState<StripeComplete[]>([]);
    const [companies, setCompanies] = useState<Company[]>([]);
    const [singleValue, setSingleValue] = useState<StripeComplete>(empty);
    const [listFilteredData, setListFilteredData] = useState<StripeComplete[]>([]);
    const [listChartWth, setListChartWth] = useState<Chart[]>([]);
    const [loading, setLoading] = useState(true);
    const [globalFilter, setGlobalFilter] = useState<string>('');
    const isNew = useRef(false);
    const form = useForm();
    const formEdit = useForm({ mode: "onChange" });
    const [editingRows, setEditingRows] = useState({});
    const errors = form.formState.errors;
    const toast = useRef<any>(null);
    const [deleteDialog, setDeleteDialog] = useState(false);
    const { accounts } = useMsal();
    const [updateTrigger, setUpdateTrigger] = useState(0);
    const dt = useRef<any>(null);

    useEffect(() => {
        initFilters();
        MaintenanceService.getStripes().then(data => {
            setListValues(data);
            setLoading(false);
        });

        MaintenanceService.getChartsByType('WTH').then(data => {
            setListChartWth(data);
            setLoading(false);
        });

        MaintenanceService.getCompanies().then(data => {
            setCompanies(data);
            setLoading(false);
        });
    }, []);

    useEffect(() => {
        MaintenanceService.getStripes().then(data => {
            setListValues(data);
            setLoading(false);
        });
    }, [updateTrigger]);

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const getFilteredData = () => {
        const data = listFilteredData.length > 0 ? listFilteredData : dt.current.props.value;

        const bodyData = data.map((item: StripeComplete) => [
            item.stripeStyle,
            item.stripeDesc,
            item.stripeNumClr,
            item.stripeWthChart,
            item.stripeBackground,
            item.stripeNeckStyle,
            item.stripeCompanyId,
            item.stripeStatus,
            item.stripeAltLoc1,
            item.stripeAltLoc2,
            item.stripeAltLoc3,
            item.stripeAltLoc4,
            item.stripeAltLoc5,
            item.stripeAltLoc6,
            item.stripeUpdUser,
            item.stripeUpdTs
        ]);

        return bodyData;
    };

    const exportPdf = () => {
        const bodyData = getFilteredData();
        import('jspdf').then((jsPDF) => {
            import('jspdf-autotable').then(() => {
                const doc = new jsPDF.default("l");
                autoTable(doc, { head: [['Style', 'Description', '# of Colors', 'With Chart', 'Background', 'Neck Style', 'Company ID', 'Status', 'Alt Loc 1', 'Alt Loc 2', 'Alt Loc 3', 'Alt Loc 4', 'Alt Loc 5', 'Alt Loc 6', 'Specialty', 'Update User', 'Update Date']], body: bodyData })
                doc.save('stripes.pdf');
            });
        });
    };

    const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        let _filters = { ...filters };

        // @ts-ignore
        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilter(value);
    };

    const [filters, setFilters] = useState<DataTableFilterMeta>(defaultFilters);
    const initFilters = () => {
        let _filters = { ...filters };

        // @ts-ignore
        _filters['global'].value = null;
        setFilters(defaultFilters);
        setGlobalFilter('');
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <div>
                <i className="pi pi-file-excel ml-3 text-green-500 cursor-pointer" title="Export CSV" onClick={(e) => { exportCSV(); e.stopPropagation(); }} />
                <i className="pi pi-file-pdf ml-3 text-red-500 cursor-pointer" title="Export PDF" onClick={(e) => { exportPdf(); e.stopPropagation(); }} />
            </div>
            <IconField iconPosition="left">
                <InputIcon className="pi pi-search" />
                <InputText className="p-inputtext-sm" type="search" autoComplete="off" value={globalFilter} onChange={onGlobalFilterChange} placeholder="Search..." />
            </IconField>
        </div>
    );

    const styleDropdownWidthTemplate = (option: Chart) => {
        return (option.chartCd + ' - ' + option.chartDesc);
    };

    const selectedStyleDropdownWidthTemplate = (option: Chart, props: any) => {
        if (option) {
            return (option.chartCd + ' - ' + option.chartDesc);
        }

        return <span>{props.placeholder}</span>;
    };

    const stripeStyleTemplate = (rowData: StripeComplete) => {
        return rowData.stripeStyle;
    };

    const stripeDescTemplate = (rowData: StripeComplete) => {
        return rowData.stripeDesc;
    };

    const stripeNumClrTemplate = (rowData: StripeComplete) => {
        return rowData.stripeNumClr;
    };

    const stripeWthChartTemplate = (rowData: StripeComplete) => {
        return rowData.stripeWthChart;
    };

    const stripeBackgroundTemplate = (rowData: StripeComplete) => {
        if (rowData.stripeBackground === "Y") {
            return (
                <>
                    <i className="pi pi-check text-green-500"></i>
                </>
            );
        } else {
            return (
                <>
                    <i className="pi pi-times text-red-500"></i>
                </>
            );
        }
    };

    const stripeNeckStyleTemplate = (rowData: StripeComplete) => {
        return rowData.stripeNeckStyle;
    };

    const stripeCompanyIdTemplate = (rowData: StripeComplete) => {
        return rowData.stripeCompanyId;
    };

    const stripeStatusTemplate = (rowData: StripeComplete) => {
        return rowData.stripeStatus;
    };

    const stripeAltLoc1Template = (rowData: StripeComplete) => {
        if (rowData.stripeAltLoc1 === "Y") {
            return (
                <>
                    <i className="pi pi-check text-green-500"></i>
                </>
            );
        } else {
            return (
                <>
                    <i className="pi pi-times text-red-500"></i>
                </>
            );
        }
    };

    const stripeAltLoc2Template = (rowData: StripeComplete) => {
        if (rowData.stripeAltLoc2 === "Y") {
            return (
                <>
                    <i className="pi pi-check text-green-500"></i>
                </>
            );
        } else {
            return (
                <>
                    <i className="pi pi-times text-red-500"></i>
                </>
            );
        }
    };

    const stripeAltLoc3Template = (rowData: StripeComplete) => {
        if (rowData.stripeAltLoc3 === "Y") {
            return (
                <>
                    <i className="pi pi-check text-green-500"></i>
                </>
            );
        } else {
            return (
                <>
                    <i className="pi pi-times text-red-500"></i>
                </>
            );
        }
    };

    const stripeAltLoc4Template = (rowData: StripeComplete) => {
        if (rowData.stripeAltLoc4 === "Y") {
            return (
                <>
                    <i className="pi pi-check text-green-500"></i>
                </>
            );
        } else {
            return (
                <>
                    <i className="pi pi-times text-red-500"></i>
                </>
            );
        }
    };

    const stripeAltLoc5Template = (rowData: StripeComplete) => {
        if (rowData.stripeAltLoc5 === "Y") {
            return (
                <>
                    <i className="pi pi-check text-green-500"></i>
                </>
            );
        } else {
            return (
                <>
                    <i className="pi pi-times text-red-500"></i>
                </>
            );
        }
    };

    const stripeAltLoc6Template = (rowData: StripeComplete) => {
        if (rowData.stripeAltLoc6 === "Y") {
            return (
                <>
                    <i className="pi pi-check text-green-500"></i>
                </>
            );
        } else {
            return (
                <>
                    <i className="pi pi-times text-red-500"></i>
                </>
            );
        }
    };

    const stripeUpdUserTemplate = (rowData: StripeComplete) => {
        return rowData.stripeUpdUser;
    };

    const stripeUpdTsTemplate = (rowData: StripeComplete) => {
        return rowData.stripeUpdTs;
    };

    const clearNew = () => {
        form.reset();
    }

    const getErrorMessage = (name: string) => {
        return errors[name] ? <small className="p-error">{(errors[name] as any).message}</small> : <small className="p-error">&nbsp;</small>;
    };

    const onSubmit = (data: any) => {
        isNew.current = true;
        let _value = { ...singleValue };

        _value.stripeStyle = data.stripeStyle;
        _value.stripeDesc = data.stripeDesc;
        _value.stripeNumClr = data.stripeNumClr;
        _value.stripeWthChart = data.stripeWthChart;
        _value.stripeBackground = data.stripeBackground ? 'Y' : 'N';
        _value.stripeNeckStyle = data.stripeNeckStyle;
        _value.stripeCompanyId = data.stripeCompanyId;
        _value.stripeStatus = data.stripeStatus;
        _value.stripeAltLoc1 = data.stripeAltLoc1 ? 'Y' : 'N';
        _value.stripeAltLoc2 = data.stripeAltLoc2 ? 'Y' : 'N';
        _value.stripeAltLoc3 = data.stripeAltLoc3 ? 'Y' : 'N';
        _value.stripeAltLoc4 = data.stripeAltLoc4 ? 'Y' : 'N';
        _value.stripeAltLoc5 = data.stripeAltLoc5 ? 'Y' : 'N';
        _value.stripeAltLoc6 = data.stripeAltLoc6 ? 'Y' : 'N';

        if (accounts[0]) {
            _value.stripeUpdTs = new Date().toISOString();
            _value.stripeUpdUser = accounts[0].username.split('@')[0];
        }

        save(_value);
        form.reset();
    };


    const save = (value: StripeComplete) => {
        MaintenanceService.addStripe(value).then(() => {
            setUpdateTrigger(prev => prev + 1);
            toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Stripe Created', life: 3000 });
            setSingleValue(empty);
        }).catch(() => {
            toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to Create Stripe', life: 3000 });
        });
    }

    const update = (value: StripeComplete, oldId: string) => {
        MaintenanceService.updateStripe(value, oldId).then(() => {
            setUpdateTrigger(prev => prev + 1);
            toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Stripe Updated', life: 3000 });
            setSingleValue(empty);
        }).catch(() => {
            toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to Update Stripe', life: 3000 });
        });
    }

    const setActiveRowIndexCE = (rowData: DataTableSelectionSingleChangeEvent<StripeComplete[]>) => {
        let selectedIndex = listValues.findIndex(v => v.stripeStyle === (rowData.value as StripeComplete).stripeStyle);
        let _editingRows = { ...editingRows, ...{ [`${listValues[selectedIndex].stripeStyle}`]: true } };
        if (Object.keys(_editingRows).length === 1) {
            setEditingRows(_editingRows);
        }
    }

    const onRowEditChange = (e: any) => {
        setEditingRows(e.data);
    }

    const cellEditor = (options: ColumnEditorOptions) => {
        switch (options.field) {
            case 'stripeStyle':
                return stripeStyleEditor(options);

            case 'stripeDesc':
                return stripeDescEditor(options);

            case 'stripeNumClr':
                return stripeNumClrEditor(options);

            case 'stripeWthChart':
                return stripeWthChartEditor(options);

            case 'stripeBackground':
                return stripeBackgroundEditor(options);

            case 'stripeNeckStyle':
                return stripeNeckStyleEditor(options);

            case 'stripeCompanyId':
                return stripeCompanyIdEditor(options);

            case 'stripeStatus':
                return stripeStatusEditor(options);

            case 'stripeAltLoc1':
                return stripeAltLoc1Editor(options);

            case 'stripeAltLoc2':
                return stripeAltLoc2Editor(options);

            case 'stripeAltLoc3':
                return stripeAltLoc3Editor(options);

            case 'stripeAltLoc4':
                return stripeAltLoc4Editor(options);

            case 'stripeAltLoc5':
                return stripeAltLoc5Editor(options);

            case 'stripeAltLoc6':
                return stripeAltLoc6Editor(options);

            default:
                return null;
        }
    }

    const stripeStyleEditor = (options: any) => {
        return (
            <Controller
                name="stripeStyleEdit"
                control={formEdit.control}
                defaultValue={options.value}
                rules={{
                    required: 'Style is required.',
                    maxLength: {
                        value: 15,
                        message: 'Style must be at most 15 characters.',
                    },
                }}
                render={({ field, fieldState }) => {
                    singleValue.stripeStyle = field.value;
                    return (
                        <>
                            <InputText ref={field.ref} value={fieldState.isDirty ? field.value : options.value} maxLength={15} tooltip={fieldState.error?.message} tooltipOptions={{ position: 'bottom' }} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => { singleValue.stripeStyle = e.target.value; field.onChange(e.target.value.toUpperCase()); }} placeholder="Style" />
                        </>
                    )
                }}
            />
        );
    }

    const stripeDescEditor = (options: any) => {
        return (
            <Controller
                name="stripeDescEdit"
                control={formEdit.control}
                defaultValue={options.value}
                rules={{
                    required: 'Description is required.',
                    maxLength: {
                        value: 25,
                        message: 'Description must be at most 25 characters.',
                    },
                }}
                render={({ field, fieldState }) => {
                    singleValue.stripeDesc = field.value;
                    return (
                        <>
                            <InputText ref={field.ref} value={fieldState.isDirty ? field.value : options.value} maxLength={25} tooltip={fieldState.error?.message} tooltipOptions={{ position: 'bottom' }} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => { singleValue.stripeDesc = e.target.value; field.onChange(e.target.value.toUpperCase()); }} placeholder="Description" />
                        </>
                    )
                }}
            />
        );
    }

    const stripeNumClrEditor = (options: any) => {
        return (
            <Controller
                name="stripeNumClrEdit"
                control={formEdit.control}
                defaultValue={options.value}
                rules={{
                    required: '# of Colors is required.',
                    max: {
                        value: 99,
                        message: '# of Colors must be at most 99.',
                    },
                }}
                render={({ field, fieldState }) => {
                    singleValue.stripeNumClr = field.value;
                    return (
                        <>
                            <InputNumber ref={field.ref} value={fieldState.isDirty ? field.value : options.value} max={99} tooltip={fieldState.error?.message} tooltipOptions={{ position: 'bottom' }} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onValueChange={(e) => { singleValue.stripeNumClr = e.value ?? 0; field.onChange(e.value); }} placeholder="# of Colors" />
                        </>
                    )
                }}
            />
        );
    }

    const stripeWthChartEditor = (options: any) => {
        return (
            <Controller
                name="stripeWthChartEdit"
                control={formEdit.control}
                defaultValue={options.value}
                rules={{
                    required: 'Width Chart is required.'
                }}
                render={({ field, fieldState }) => {
                    singleValue.stripeWthChart = field.value;
                    return (
                        <>
                            <Dropdown ref={field.ref} inputId={field.name} value={fieldState.isDirty ? field.value : options.value} options={listChartWth} optionLabel="chartDesc" optionValue="chartCd" itemTemplate={styleDropdownWidthTemplate} valueTemplate={selectedStyleDropdownWidthTemplate} tooltip={fieldState.error?.message} tooltipOptions={{ position: 'bottom' }} className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                onChange={(e) => { singleValue.stripeWthChart = e.target.value; field.onChange(e.value) }} placeholder="Select..." />
                        </>
                    )
                }
                }
            />
        );
    }

    const stripeBackgroundEditor = (options: any) => {
        return (
            <Controller
                name="stripeBackgroundEdit"
                control={formEdit.control}
                defaultValue={options.value === 'Y'}
                render={({ field, fieldState }) => {
                    singleValue.stripeBackground = field.value ? 'Y' : 'N';
                    return (
                        <React.Fragment>
                            <Checkbox
                                inputId={field.name}
                                checked={fieldState.isDirty ? field.value : options.value === 'Y'}
                                inputRef={field.ref}
                                className={classNames('col-offset-0', { 'p-invalid mr-1': fieldState.error })}
                                onChange={(e) => {
                                    const checked = e.checked;
                                    singleValue.stripeBackground = checked ? 'Y' : 'N';
                                    field.onChange(checked);
                                }}
                            />
                        </React.Fragment>
                    );
                }}
            />
        );
    }


    const stripeNeckStyleEditor = (options: any) => {
        return (
            <Controller
                name="stripeNeckStyleEdit"
                control={formEdit.control}
                defaultValue={options.value}
                render={({ field, fieldState }) => {
                    singleValue.stripeNeckStyle = field.value;
                    return (
                        <>
                            <InputText ref={field.ref} value={fieldState.isDirty ? field.value : options.value} maxLength={3} tooltip={fieldState.error?.message} tooltipOptions={{ position: 'bottom' }} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => { singleValue.stripeNeckStyle = e.target.value; field.onChange(e.target.value.toUpperCase()); }} placeholder="Neck Style" />
                        </>
                    )
                }}
            />
        );
    }

    const stripeStatusEditor = (options: any) => {
        return (
            <Controller
                name="stripeStatusEdit"
                control={formEdit.control}
                defaultValue={options.value}
                rules={{
                    required: 'Status is required.'
                }}
                render={({ field, fieldState }) => {
                    singleValue.stripeStatus = field.value;
                    return (
                        <>
                            <Dropdown ref={field.ref} inputId={field.name} value={fieldState.isDirty ? field.value : options.value} options={status} optionLabel="name" optionValue="code" tooltip={fieldState.error?.message} tooltipOptions={{ position: 'bottom' }} className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                onChange={(e) => { singleValue.stripeStatus = e.target.value; field.onChange(e.value) }} placeholder="Select..." />
                        </>
                    )
                }}
            />
        );
    }

    const stripeCompanyIdEditor = (options: any) => {
        return (
            <Controller
                name="stripeCompanyId"
                control={formEdit.control}
                defaultValue={options.value}
                rules={{
                    required: 'Company is required.'
                }}
                render={({ field, fieldState }) => {
                    singleValue.stripeCompanyId = field.value;
                    return (
                        <>
                            <Dropdown ref={field.ref} inputId={field.name} value={fieldState.isDirty ? field.value : options.value} options={companies} optionLabel="companyName" optionValue="companyId" tooltip={fieldState.error?.message} tooltipOptions={{ position: 'bottom' }} className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                onChange={(e) => { singleValue.stripeCompanyId = e.target.value; field.onChange(e.value) }} placeholder="Select..." />
                        </>
                    )
                }}
            />
        );
    }

    const stripeAltLoc1Editor = (options: any) => {
        return (
            <Controller
                name="stripeAltLoc1Edit"
                control={formEdit.control}
                defaultValue={options.value === 'Y'}
                render={({ field, fieldState }) => {
                    singleValue.stripeAltLoc1 = field.value ? 'Y' : 'N';
                    return (
                        <React.Fragment>
                            <Checkbox
                                inputId={field.name}
                                checked={fieldState.isDirty ? field.value : options.value === 'Y'}
                                inputRef={field.ref}
                                className={classNames('col-offset-0', { 'p-invalid mr-1': fieldState.error })}
                                onChange={(e) => {
                                    const checked = e.checked;
                                    singleValue.stripeAltLoc1 = checked ? 'Y' : 'N';
                                    field.onChange(checked);
                                }}
                            />
                        </React.Fragment>
                    );
                }}
            />
        );
    }

    const stripeAltLoc2Editor = (options: any) => {
        return (
            <Controller
                name="stripeAltLoc2Edit"
                control={formEdit.control}
                defaultValue={options.value === 'Y'}
                render={({ field, fieldState }) => {
                    singleValue.stripeAltLoc2 = field.value ? 'Y' : 'N';
                    return (
                        <React.Fragment>
                            <Checkbox
                                inputId={field.name}
                                checked={fieldState.isDirty ? field.value : options.value === 'Y'}
                                inputRef={field.ref}
                                className={classNames('col-offset-0', { 'p-invalid mr-1': fieldState.error })}
                                onChange={(e) => {
                                    const checked = e.checked;
                                    singleValue.stripeAltLoc2 = checked ? 'Y' : 'N';
                                    field.onChange(checked);
                                }}
                            />
                        </React.Fragment>
                    );
                }}
            />
        );
    }

    const stripeAltLoc3Editor = (options: any) => {
        return (
            <Controller
                name="stripeAltLoc3Edit"
                control={formEdit.control}
                defaultValue={options.value === 'Y'}
                render={({ field, fieldState }) => {
                    singleValue.stripeAltLoc3 = field.value ? 'Y' : 'N';
                    return (
                        <React.Fragment>
                            <Checkbox
                                inputId={field.name}
                                checked={fieldState.isDirty ? field.value : options.value === 'Y'}
                                inputRef={field.ref}
                                className={classNames('col-offset-0', { 'p-invalid mr-1': fieldState.error })}
                                onChange={(e) => {
                                    const checked = e.checked;
                                    singleValue.stripeAltLoc3 = checked ? 'Y' : 'N';
                                    field.onChange(checked);
                                }}
                            />
                        </React.Fragment>
                    );
                }}
            />
        );
    }

    const stripeAltLoc4Editor = (options: any) => {
        return (
            <Controller
                name="stripeAltLoc4Edit"
                control={formEdit.control}
                defaultValue={options.value === 'Y'}
                render={({ field, fieldState }) => {
                    singleValue.stripeAltLoc4 = field.value ? 'Y' : 'N';
                    return (
                        <React.Fragment>
                            <Checkbox
                                inputId={field.name}
                                checked={fieldState.isDirty ? field.value : options.value === 'Y'}
                                inputRef={field.ref}
                                className={classNames('col-offset-0', { 'p-invalid mr-1': fieldState.error })}
                                onChange={(e) => {
                                    const checked = e.checked;
                                    singleValue.stripeAltLoc4 = checked ? 'Y' : 'N';
                                    field.onChange(checked);
                                }}
                            />
                        </React.Fragment>
                    );
                }}
            />
        );
    }

    const stripeAltLoc5Editor = (options: any) => {
        return (
            <Controller
                name="stripeAltLoc5Edit"
                control={formEdit.control}
                defaultValue={options.value === 'Y'}
                render={({ field, fieldState }) => {
                    singleValue.stripeAltLoc5 = field.value ? 'Y' : 'N';
                    return (
                        <React.Fragment>
                            <Checkbox
                                inputId={field.name}
                                checked={fieldState.isDirty ? field.value : options.value === 'Y'}
                                inputRef={field.ref}
                                className={classNames('col-offset-0', { 'p-invalid mr-1': fieldState.error })}
                                onChange={(e) => {
                                    const checked = e.checked;
                                    singleValue.stripeAltLoc5 = checked ? 'Y' : 'N';
                                    field.onChange(checked);
                                }}
                            />
                        </React.Fragment>
                    );
                }}
            />
        );
    }

    const stripeAltLoc6Editor = (options: any) => {
        return (
            <Controller
                name="stripeAltLoc6Edit"
                control={formEdit.control}
                defaultValue={options.value === 'Y'}
                render={({ field, fieldState }) => {
                    singleValue.stripeAltLoc6 = field.value ? 'Y' : 'N';
                    return (
                        <React.Fragment>
                            <Checkbox
                                inputId={field.name}
                                checked={fieldState.isDirty ? field.value : options.value === 'Y'}
                                inputRef={field.ref}
                                className={classNames('col-offset-0', { 'p-invalid mr-1': fieldState.error })}
                                onChange={(e) => {
                                    const checked = e.checked;
                                    singleValue.stripeAltLoc6 = checked ? 'Y' : 'N';
                                    field.onChange(checked);
                                }}
                            />
                        </React.Fragment>
                    );
                }}
            />
        );
    }

    const rowEditorTemplate = (rowData: StripeComplete, props: any) => {
        const rowEditor = props.rowEditor;

        if (rowEditor.editing) {
            isNew.current = false;

            return (
                <>
                    <Button icon="p-row-editor-save-icon pi pi-fw pi-save" title="Save" rounded text severity="info" type="submit" onClick={(e) => {
                        if (!formEdit.getFieldState("categoryCdEdit").invalid && !formEdit.getFieldState("categoryDescEdit").invalid) {
                            let _singleValue = { ...singleValue };
                            let oldId = rowData.stripeStyle;

                            if (accounts[0]) {
                                _singleValue.stripeUpdTs = new Date().toISOString();
                                _singleValue.stripeUpdUser = accounts[0].username.split('@')[0];
                            }

                            update(_singleValue, oldId);
                            formEdit.reset();
                            rowEditor.onSaveClick(e);
                        }
                    }} />

                    <Button icon="p-row-editor-cancel-icon pi pi-fw pi-undo" title="Undo" rounded text severity="danger" onClick={(e) => {
                        formEdit.clearErrors();
                        formEdit.reset();
                        rowEditor.onCancelClick(e);
                    }} />
                </>
            );
        } else {
            return (
                <Link className="pi pi-fw pi-trash rowDelete" title="Delete" onClick={() => confirmDelete(rowData)} to={''}></Link>
            );
        }
    }

    const hideDeleteDialog = () => {
        setDeleteDialog(false);
    };

    const confirmDelete = (value: StripeComplete) => {
        setSingleValue(value);
        setDeleteDialog(true);
    }

    const deleteRow = () => {
        MaintenanceService.deleteStripe(singleValue.stripeStyle).then(() => {
            setUpdateTrigger(prev => prev + 1);
            setDeleteDialog(false);
            setSingleValue(empty);
            toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Deleted', life: 3000 });
        }).catch(() => {
            toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to remove', life: 3000 });
        });

    };

    const deleteDialogFooter = (
        <React.Fragment>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hideDeleteDialog} />
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteRow} />
        </React.Fragment>
    );

    return (
        <>
            <Toast ref={toast} />

            <Panel header="Add Stripe" className="addPanel mb-2 -ml-2">
                <form onSubmit={form.handleSubmit(onSubmit)} className="p-fluid" autoComplete="off">
                    <div className="formgrid grid">
                        <div className="field col-2">
                            <Controller
                                name="stripeStyle"
                                control={form.control}
                                defaultValue=""
                                rules={{
                                    required: 'Style is required.',
                                    maxLength: {
                                        value: 15,
                                        message: 'Style must be at most 15 characters.',
                                    },
                                    validate: {
                                        unique: v => listValues.filter(val => val.stripeStyle.toLowerCase() === v.toLowerCase()).length === 0 || 'Stripe style must be unique.'
                                    }
                                }}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className="font-bold text-xs">Stripe Style</label>
                                        <InputText id={field.name} name={field.name} value={field.value} maxLength={15} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => { field.onChange(e.target.value.toUpperCase()); }} placeholder="Style" />
                                        {getErrorMessage('stripeStyle')}
                                    </>
                                )}
                            />
                        </div>
                        <div className="field col-2">
                            <Controller
                                name="stripeDesc"
                                control={form.control}
                                defaultValue=""
                                rules={{
                                    required: 'Description is required.',
                                    maxLength: {
                                        value: 25,
                                        message: 'Description must be at most 25 characters.',
                                    },
                                }}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className="font-bold text-xs">Description</label>
                                        <InputText id={field.name} name={field.name} value={field.value} maxLength={25} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => field.onChange(e.target.value.toUpperCase())} placeholder="Description" />
                                        {getErrorMessage('stripeDesc')}
                                    </>
                                )}
                            />
                        </div>
                        <div className="field col-2">
                            <Controller
                                name="stripeNumClr"
                                control={form.control}
                                defaultValue={0}
                                rules={{
                                    required: '# of Colors is required.',
                                    max: {
                                        value: 99,
                                        message: '# of Colors must be at most 99.',
                                    },
                                }}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className="font-bold text-xs"># Of Colors</label>
                                        <InputNumber id={field.name} name={field.name} value={field.value} max={99} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onValueChange={(e) => field.onChange(e.value)} placeholder="# of Colors" />
                                        {getErrorMessage('stripeNumClr')}
                                    </>
                                )}
                            />
                        </div>
                        <div className="field col-2">
                            <Controller
                                name="stripeWthChart"
                                control={form.control}
                                defaultValue=""
                                rules={{
                                    required: 'Width Chart is required.'
                                }}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Width Chart</label>
                                        <Dropdown inputId={field.name} filter value={field.value} options={listChartWth} optionLabel="chartDesc" optionValue="chartCd" itemTemplate={styleDropdownWidthTemplate} valueTemplate={selectedStyleDropdownWidthTemplate} className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                            onChange={(e) => { field.onChange(e.value) }} placeholder="Select..." />
                                        {getErrorMessage('stripeWthChart')}
                                    </>
                                )}
                            />
                        </div>
                        <div className="field col-fixed isCheckbox">
                            <Controller
                                name="stripeBackground"
                                control={form.control}
                                defaultValue={false}
                                render={({ field, fieldState }) => (
                                    <React.Fragment>
                                        <label htmlFor={field.name} className="font-bold text-xs">Background</label><br />
                                        <Checkbox
                                            inputId={field.name}
                                            checked={field.value}
                                            inputRef={field.ref}
                                            className={classNames('col-offset-4', { 'p-invalid mr-1': fieldState.error })}
                                            onChange={(e) => field.onChange(e.checked)}
                                        />
                                    </React.Fragment>
                                )}
                            />
                        </div>
                        <div className="field col-2">
                            <Controller
                                name="stripeNeckStyle"
                                control={form.control}
                                defaultValue=""
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className="font-bold text-xs">AS400 Neck Style</label>
                                        <InputText id={field.name} name={field.name} value={field.value} maxLength={3} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => field.onChange(e.target.value.toUpperCase())} placeholder="Neck Style" />
                                        {getErrorMessage('stripeNeckStyle')}
                                    </>
                                )}
                            />
                        </div>
                        <div className="field col-2">
                            <Controller
                                name="stripeCompanyId"
                                control={form.control}
                                rules={{
                                    required: 'Company is required.'
                                }}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className="font-bold text-xs">Company</label>
                                        <Dropdown inputId={field.name} value={field.value} options={companies} optionLabel="companyName" optionValue="companyId" className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                            onChange={(e) => { field.onChange(e.value) }} placeholder="Select..." />
                                        {getErrorMessage('stripeCompanyId')}
                                    </>
                                )}
                            />
                        </div>
                        <div className="field col-2">
                            <Controller
                                name="stripeStatus"
                                control={form.control}
                                defaultValue={'A'}
                                rules={{
                                    required: 'Status is required.'
                                }}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className="font-bold text-xs">Status</label>
                                        <Dropdown inputId={field.name} value={field.value} options={status} optionLabel="name" optionValue="code" className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                            onChange={(e) => { field.onChange(e.value) }} placeholder="Select..." />
                                        {getErrorMessage('stripeStatus')}
                                    </>
                                )}
                            />
                        </div>
                        <div className="field col-fixed isCheckbox">
                            <Controller
                                name="stripeAltLoc1"
                                control={form.control}
                                defaultValue={false}
                                render={({ field, fieldState }) => (
                                    <React.Fragment>
                                        <label htmlFor={field.name} className="font-bold text-xs">Alt Chart Sect 1</label><br />
                                        <Checkbox
                                            inputId={field.name}
                                            checked={field.value}
                                            inputRef={field.ref}
                                            className={classNames('col-offset-4', { 'p-invalid mr-1': fieldState.error })}
                                            onChange={(e) => field.onChange(e.checked)}
                                        />
                                    </React.Fragment>
                                )}
                            />
                        </div>


                        <div className="field col-fixed isCheckbox">
                            <Controller
                                name="stripeAltLoc2"
                                control={form.control}
                                defaultValue={false}
                                render={({ field, fieldState }) => (
                                    <React.Fragment>
                                        <label htmlFor={field.name} className="font-bold text-xs">Alt Chart Sect 2</label><br />
                                        <Checkbox
                                            inputId={field.name}
                                            checked={field.value}
                                            inputRef={field.ref}
                                            className={classNames('col-offset-4', { 'p-invalid mr-1': fieldState.error })}
                                            onChange={(e) => field.onChange(e.checked)}
                                        />
                                    </React.Fragment>
                                )}
                            />
                        </div>
                        <div className="field col-fixed isCheckbox">
                            <Controller
                                name="stripeAltLoc3"
                                control={form.control}
                                defaultValue={false}
                                render={({ field, fieldState }) => (
                                    <React.Fragment>
                                        <label htmlFor={field.name} className="font-bold text-xs">Alt Chart Sect 3</label><br />
                                        <Checkbox
                                            inputId={field.name}
                                            checked={field.value}
                                            inputRef={field.ref}
                                            className={classNames('col-offset-4', { 'p-invalid mr-1': fieldState.error })}
                                            onChange={(e) => field.onChange(e.checked)}
                                        />
                                    </React.Fragment>
                                )}
                            />
                        </div>
                        <div className="field col-fixed isCheckbox">
                            <Controller
                                name="stripeAltLoc4"
                                control={form.control}
                                defaultValue={false}
                                render={({ field, fieldState }) => (
                                    <React.Fragment>
                                        <label htmlFor={field.name} className="font-bold text-xs">Alt Chart Sect 4</label><br />
                                        <Checkbox
                                            inputId={field.name}
                                            checked={field.value}
                                            inputRef={field.ref}
                                            className={classNames('col-offset-4', { 'p-invalid mr-1': fieldState.error })}
                                            onChange={(e) => field.onChange(e.checked)}
                                        />
                                    </React.Fragment>
                                )}
                            />
                        </div>
                        <div className="field col-fixed isCheckbox">
                            <Controller
                                name="stripeAltLoc5"
                                control={form.control}
                                defaultValue={false}
                                render={({ field, fieldState }) => (
                                    <React.Fragment>
                                        <label htmlFor={field.name} className="font-bold text-xs">Alt Chart Sect 5</label><br />
                                        <Checkbox
                                            inputId={field.name}
                                            checked={field.value}
                                            inputRef={field.ref}
                                            className={classNames('col-offset-4', { 'p-invalid mr-1': fieldState.error })}
                                            onChange={(e) => field.onChange(e.checked)}
                                        />
                                    </React.Fragment>
                                )}
                            />
                        </div>
                        <div className="field col-fixed isCheckbox">
                            <Controller
                                name="stripeAltLoc6"
                                control={form.control}
                                defaultValue={false}
                                render={({ field, fieldState }) => (
                                    <React.Fragment>
                                        <label htmlFor={field.name} className="font-bold text-xs">Alt Chart Sect 6</label><br />
                                        <Checkbox
                                            inputId={field.name}
                                            checked={field.value}
                                            inputRef={field.ref}
                                            className={classNames('col-offset-4', { 'p-invalid mr-1': fieldState.error })}
                                            onChange={(e) => field.onChange(e.checked)}
                                        />
                                    </React.Fragment>
                                )}
                            />
                        </div>
                        <div className="field field-buttons col-2 pt-4">
                            <Button icon="pi pi-save" title="Save" rounded text severity="info" type="submit" />
                            <Button icon="pi pi-undo" title="Undo" rounded text severity="danger" type="button" onClick={clearNew} />
                        </div>
                    </div>

                </form>
            </Panel>

            <DataTable ref={dt} className="-ml-2" value={listValues} selectionMode="single" onSelectionChange={setActiveRowIndexCE}
                dataKey="stripeStyle" size="small" rowHover={true} loading={loading}
                scrollable scrollHeight="calc(100vh - 23.9rem)"
                paginator rows={25} rowsPerPageOptions={[5, 10, 25]} alwaysShowPaginator={false}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                editingRows={editingRows} editMode="row" onRowEditChange={onRowEditChange}
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records"
                filters={filters} header={header} onValueChange={filteredData => setListFilteredData(filteredData)}
                emptyMessage="No category records found.">
                <Column field="stripeStyle" header="Stripe Style" sortable body={stripeStyleTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="stripeDesc" header="Description" sortable body={stripeDescTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '15%', minWidth: '15rem' }}></Column>
                <Column field="stripeNumClr" header="No of Colors" sortable body={stripeNumClrTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="stripeWthChart" header="Width Chart" sortable body={stripeWthChartTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="stripeBackground" header="Background" sortable body={stripeBackgroundTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="stripeCompanyId" header="Company" sortable body={stripeCompanyIdTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="stripeStatus" header="Status" sortable body={stripeStatusTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="stripeNeckStyle" header="Neck Style" sortable body={stripeNeckStyleTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="stripeAltLoc1" header="Alt Chart Sect 1" sortable body={stripeAltLoc1Template} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="stripeAltLoc2" header="Alt Chart Sect 2" sortable body={stripeAltLoc2Template} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="stripeAltLoc3" header="Alt Chart Sect 3" sortable body={stripeAltLoc3Template} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="stripeAltLoc4" header="Alt Chart Sect 4" sortable body={stripeAltLoc4Template} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="stripeAltLoc5" header="Alt Chart Sect 5" sortable body={stripeAltLoc5Template} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="stripeAltLoc6" header="Alt Chart Sect 6" sortable body={stripeAltLoc6Template} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="stripeUpdUser" header="Update User" sortable body={stripeUpdUserTemplate} filter filterPlaceholder="Search..." align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="stripeUpdTs" header="Update Date" sortable body={stripeUpdTsTemplate} filter filterPlaceholder="Search..." align="center" alignHeader="center" headerStyle={{ width: '15%', minWidth: '15rem' }}></Column>
                <Column rowEditor body={rowEditorTemplate} headerStyle={{ width: '10%', minWidth: '8rem' }} bodyStyle={{ textAlign: 'center' }}></Column>
            </DataTable>

            <Dialog visible={deleteDialog} style={{ width: '32rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Confirm" modal footer={deleteDialogFooter} onHide={hideDeleteDialog}>
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    {singleValue && (
                        <span>
                            Are you sure you want to delete <b>{singleValue.stripeStyle} - {singleValue.stripeDesc}</b>?
                        </span>
                    )}
                </div>
            </Dialog>
        </>
    )
}